"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    local: 'localhost',
    baseDomain: 'lumirental.com',
};
